import './Units.css';
import t from '../../Utils/Translation';
import UnitSplider from './../common/UnitSplider';

const Units = (props) => {
	const title = props.title;
	const units = props.units;
	const hideTitle = props.hideTitle;
	const makeHeadersDark = props.makeHeadersDark;

	return (
			<div className={`lykiocss-units-div`}>
			{!hideTitle &&  
				<h1 className={`lykiocss-slider-title ${makeHeadersDark && 'lykiocss-dark-color'}`}>{t(title)}</h1>
			}
			{units.length < 1 ? (
			<div style={{ margin: '0 auto', textAlign: 'center' }}>{t('No content yet!')}</div>
			) : <UnitSplider units={units}/>
			}
			</div>
	);
};

export default Units;
